export default __webpack_public_path__ + "static/media/spratt10.67b7fb32.jpg";